import React, { useEffect, useState } from 'react';
import Spinner from 'components/loader/Spinner';
import useUpdatePipeline from '../hooks/useUpdatePipeline';
import NTextAreaQuill from 'components/Inputs/TextAreaQuill/NTextAreaQuill';
import { NButton, NDialog } from '@innersource-nn/novoui-react';
import { ModalProps } from 'types/Modal';

const EditPipelineModal = ({ visible, onClose }: ModalProps) => {
    const [formData, setFormData] = useState('');

    const { pipeline, loading, handleSubmit, updating } = useUpdatePipeline();

    const handleClick = async () => {
        await handleSubmit(formData);
        if (onClose) onClose();
    };
    useEffect(() => {
        setFormData(pipeline.description);
    }, [pipeline]);

    return (
        <NDialog
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline="Edit pipeline details"
            primaryLabel="Console"
            size="medium"
            showDividers={false}
        >
            <div>
                {loading ? (
                    <Spinner />
                ) : (
                    <div className="flex flex-col gap-16">
                        <NTextAreaQuill
                            label="Pipeline description"
                            placeholder="Pipeline description..."
                            variant="outline"
                            modelValue={formData}
                            onChange={(value) => setFormData(value)}
                        />

                        <div className="flex justify-end">
                            <NButton
                                variant="fill"
                                size="small"
                                square
                                isLoading={updating}
                                onClick={handleClick}
                            >
                                Update pipeline
                            </NButton>
                        </div>
                    </div>
                )}
            </div>
        </NDialog>
    );
};
export default EditPipelineModal;
